import { useEffect, useState } from "react";
import "../../styles/notificationpopup.scss";
import closesvg from "../../assets/closesss.svg";
import bgSvg from "../../assets/bgNotification.svg";
import { translation } from "../../translation";
import PhonePicker from "../PhonePicker";
import IdentificationFormDone from "./IdentificationFormDone";
import {
  completerFormSchemaWithLang,
  getCompleterPhoneSchema,
} from "../Validations/validatePhonecompleter";
import { useSelector } from "react-redux";
import useCollaboratorRestriction from "../../hooks/useCollaboratorRestriction";
import {
  usePatchCreateIdentifMutation,
  useUploadPublicMutation,
} from "../../redux/appSlices/collaborator/collaboratorApiSlice";
import Lottie from "lottie-react";
import aiAnimation from "../../lotties/AiAnimation.json";

const errorsSchema = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  company: "",
};

const IdentificationForm = ({
  show,
  close,
  handleClick,
  traking,
  resId,
  dataProfile,
  dataRes,
  handleShowAuthFillPopup,
  isScanning,
  userSharedInfo,
  setUserSharedInfo,
}) => {
  const [errors, setErrors] = useState({});
  const [done, setDone] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const restriction = useCollaboratorRestriction();
  const [patchCreateIdentif] = usePatchCreateIdentifMutation();
  const [uploadPublic] = useUploadPublicMutation();

  const lang = useSelector(
    (state) => state.collaborator.collaboratorInfo.language
  );
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo
  );

  const createInitialCompleter = () => ({
    card: "",
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    prefix: "+212",
    company: "",
    function: "",
    identified_in: collaborator._id,
    updated_by_user: true,
    tracking: localStorage.getItem("tracking"),
    user_token: localStorage.getItem("user_token"),
    identification_methode: 0,
  });

  const [completer, setcompleter] = useState(createInitialCompleter());

  // Animate modal open
  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => setIsVisible(true), 30);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  // Prefill user data when available
  useEffect(() => {
    if (userSharedInfo && !done) {
      setcompleter((prev) => ({
        ...prev,
        email: userSharedInfo?.email || "",
        first_name: userSharedInfo?.first_name || "",
        last_name: userSharedInfo?.last_name || "",
        phone: userSharedInfo?.phone || "",
        function: userSharedInfo?.function || "",
        company: userSharedInfo?.company || "",
        card: userSharedInfo?.card || "",
        prefix: userSharedInfo?.prefix || "+212",
      }));
    }
  }, [userSharedInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setcompleter((prev) => ({ ...prev, [name]: value || "" }));
  };

  const validateForm = async () => {
    const newCompleter = {
      ...completer,
      phone: `${completer.prefix}-${completer.phone}`,
    };

    try {
      if (restriction?.procpect_identification === 0) {
        const schema = completerFormSchemaWithLang(lang);
        await schema.validate(newCompleter, { abortEarly: false });
      } else {
        const phoneSchema = getCompleterPhoneSchema(lang);
        await phoneSchema.validate(newCompleter, { abortEarly: false });
      }

      setErrors({});
      return true;
    } catch (err) {
      const formErrors = {};
      if (err.inner?.length > 0) {
        err.inner.forEach((e) => (formErrors[e.path] = e.message));
      } else if (err.path) {
        formErrors[err.path] = err.message;
      }
      setErrors(formErrors);
      return false;
    }
  };

  const handleSubmit = async () => {
    setErrors({ ...errorsSchema });

    try {
      const isValid = await validateForm();
      if (isValid) {
        await patchCreateIdentif({
          identifId: dataRes._id,
          content: {
            ...completer,
            phone: `${completer.prefix}${completer.phone}`,
          },
        }).unwrap();

        setDone(true);
        // Reset state after submission
        setcompleter(createInitialCompleter());
        setUserSharedInfo(createInitialCompleter());
        return true;
      } else return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      setIsVisible(false);
      setDone(false);
      setcompleter(createInitialCompleter());
      close(false);
    }, 300); // match CSS transition
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("identification-overlay")) {
      handleClose();
    }
  };

  return (
    <>
      {show && (
        <div
          className={`identification-overlay bg-black bg-opacity-30 h-[100vh] fixed top-0 z-[1000] max-w-[580px] w-full ${
            lang === "ar" ? "mr-[-20px]" : "ml-[-20px]"
          }`}
          onClick={handleOverlayClick}
        >
          <div
            className={`fixed w-full max-w-[580px] bg-white bg-no-repeat bg-contain bg-bottom rounded-t-[30px] h-[560px] z-[1001] transition-all duration-300 ease-in-out ${
              isVisible && !isClosing
                ? "bottom-0 opacity-100"
                : "bottom-[-600px] opacity-0"
            }`}
            style={{ backgroundImage: `url(${bgSvg})` }}
          >
            <img
              src={closesvg}
              className="cursor-pointer absolute right-[20px] top-[20px] h-[15px] w-[15px] object-contain z-10"
              alt="close"
              onClick={handleClose}
            />

            {!done ? (
              <div className="flex flex-col items-center p-[30px] w-full h-full relative">
                <div className="flex gap-[20px] items-center justify-center">
                  <div className="h-[60px] w-[60px] rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={
                        collaborator.profile_picture
                          ? `${process.env.REACT_APP_IMAGE_PATH}/${collaborator.profile_picture}`
                          : "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                      }
                      alt="avatar"
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <p className="text-black text-[18px]">
                    {translation?.identificationForm?.title?.[lang]}{" "}
                    {collaborator.first_name}
                  </p>
                </div>

                <div className="flex flex-col justify-between w-full">
                  <div className="flex justify-between gap-4">
                    <div className="inputWrapper w-full">
                      <input
                        type="text"
                        placeholder={
                          translation?.identificationForm?.name?.[lang]
                        }
                        className={`bg-white mt-[20px] border rounded-[15.434px] text-black text-[16px] px-[20px] py-[10px] w-full outline-none ${
                          errors.first_name
                            ? "border-[#ff4343]"
                            : "border-[#ccb7b7]"
                        }`}
                        name="first_name"
                        onChange={handleChange}
                        value={completer?.first_name}
                      />
                      {errors.first_name && (
                        <p className="text-[#ff4343]">{errors.first_name}</p>
                      )}
                    </div>

                    <div className="inputWrapper w-full">
                      <input
                        type="text"
                        placeholder={
                          translation?.identificationForm?.lastName?.[lang]
                        }
                        className={`bg-white mt-[20px] border rounded-[15.434px] text-black text-[16px] px-[20px] py-[10px] w-full outline-none ${
                          errors.last_name
                            ? "border-[#ff4343]"
                            : "border-[#ccb7b7]"
                        }`}
                        name="last_name"
                        onChange={handleChange}
                        value={completer?.last_name}
                      />
                      {errors.last_name && (
                        <p className="text-[#ff4343]">{errors.last_name}</p>
                      )}
                    </div>
                  </div>

                  <div className="inputWrapper">
                    <input
                      type={
                        restriction?._id === "6474def0c01346262758c0d1"
                          ? "text"
                          : "email"
                      }
                      placeholder={
                        restriction?._id === "6474def0c01346262758c0d1"
                          ? "Besoin"
                          : translation?.identificationForm?.email?.[lang]
                      }
                      className={`bg-white mt-[20px] border rounded-[15.434px] text-black text-[16px] px-[20px] py-[10px] w-full outline-none ${
                        errors.email ? "border-[#ff4343]" : "border-[#ccb7b7]"
                      }`}
                      name="email"
                      onChange={handleChange}
                      value={completer?.email}
                    />
                    {errors.email && (
                      <p className="text-[#ff4343]">{errors.email}</p>
                    )}
                  </div>

                  <div className="flex justify-between gap-4">
                    <div className="inputWrapper w-full">
                      <input
                        type="text"
                        placeholder={
                          translation?.identificationForm?.company?.[lang]
                        }
                        className={`bg-white mt-[20px] border rounded-[15.434px] text-black text-[16px] px-[20px] py-[10px] w-full outline-none ${
                          errors.company
                            ? "border-[#ff4343]"
                            : "border-[#ccb7b7]"
                        }`}
                        name="company"
                        onChange={handleChange}
                        value={completer?.company}
                      />
                      {errors.company && (
                        <p className="text-[#ff4343]">{errors.company}</p>
                      )}
                    </div>
                    <div className="inputWrapper w-full">
                      <input
                        type="text"
                        placeholder={
                          translation?.identificationForm?.Position?.[lang]
                        }
                        className={`bg-white mt-[20px] border rounded-[15.434px] text-black text-[16px] px-[20px] py-[10px] w-full outline-none ${
                          errors.function
                            ? "border-[#ff4343]"
                            : "border-[#ccb7b7]"
                        }`}
                        name="function"
                        onChange={handleChange}
                        value={completer?.function}
                      />
                      {errors?.function && (
                        <p className="text-[#ff4343]">{errors?.function}</p>
                      )}
                    </div>
                  </div>

                  <div className="inputWrapper">
                    <PhonePicker
                      onChange={handleChange}
                      phone={completer?.phone}
                      prefix={completer?.prefix}
                    />
                    {errors.phone && (
                      <p className="text-[#ff4343]">{errors.phone}</p>
                    )}
                  </div>

                  <button
                    onClick={handleShowAuthFillPopup}
                    className="mt-11 w-full flex items-center gap-2 bg-white px-3 transition-transform duration-200 border border-black min-w-[180px] h-[50px] rounded-[6px] text-center text-[13px] my-[20px] mx-auto cursor-pointer"
                  >
                    <div className="flex items-center gap-2 justify-between w-full h-full px-1">
                      <Lottie
                        animationData={aiAnimation}
                        height={200}
                        width={400}
                        loop
                      />
                      <span className="text-[14px] font-semibold text-gray-800">
                        {translation?.identificationForm?.auth_fill?.[lang]}
                      </span>
                      <div className="w-1" />
                    </div>
                  </button>

                  <div
                    className="w-full h-[50px] rounded-[6px] text-center text-[13px] bg-black text-white flex items-center justify-center my-[20px] mt-0 mx-auto cursor-pointer"
                    onClick={handleSubmit}
                  >
                    <p>{translation?.identificationForm?.button?.[lang]}</p>
                  </div>
                </div>

                {isScanning && (
                  <div className="absolute inset-0 h-full z-[1100] flex items-center rounded-t-[30px] justify-center bg-black bg-opacity-40">
                    <div className="flex flex-col items-center justify-center">
                      <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="NotificationPopup__content">
                <IdentificationFormDone
                  close={handleClose}
                  data={collaborator}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default IdentificationForm;
